import React from 'react'

const TCAircraft = ({data,search,DownOutlined,menu,Dropdown}) => {
    return (
        <div>
             {data?.aatmsv4_atclist?.map((data, index) => {
                if (data?.atcshortname.toLowerCase().includes(search.toLowerCase())) {
                  return (
                    <div className="table-row-container" key={index}>
                      <div className="table-row-top">
                        <div className="items">
                          <div className="title">Phase</div>
                          <div className="value">{data?.phase}</div>
                        </div>
                        <div className="items">
                          <div className="title">Technical Competency ShortName</div>
                            <div className="value">{data?.atcshortname}</div>
                        </div>
                        <div className="items">
                          <div className="title">Technical Competency Description</div>
                            <div className="value">{data?.atcname}</div>
                        </div>
                        <div className="items">
                          <div className="title">Active</div>
                          <div className="value">{data.active === true ? "True" : "False"}</div>
                        </div>
                        <Dropdown overlay={menu(data)}>
                        <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                          <i className="fa fa-ellipsis-h" />
                          <DownOutlined />
                        </a>
                         </Dropdown>
                      </div>
                    </div>
                  );
                }
              })}
        </div>
    )
}
export default TCAircraft
